import { FavoriteButton } from "@/components/vitrine/components/Favorite-button"
import { MidiaProdutoVitrine } from "@/components/vitrine/components/MidiaProdutoVitrine"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { priceFormatter } from "@/utils/formatter"
import { getLinkProduto } from "@/utils/getLinkProduto"

interface ProdutoPrincipalProps {
    hostImagem: string
    produtos: Produto[]
    precoPrincipal: number
    exibeValoresSomenteLogado: boolean
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
    vitrineButtonAddToCart: string
}

export function ProdutoPrincipal({
    hostImagem,
    produtos,
    precoPrincipal,
    exibeValoresSomenteLogado,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    vitrineButtonAddToCart
}: Readonly<ProdutoPrincipalProps>) {
    const produtoDestaque = produtos[0]
    let percentualDescontoOferta = null
    let precoOferta = 0

    if (precoPrincipal == 1 && produtoDestaque.valor_boleto && produtoDestaque.valor_boleto > 0) {
        precoOferta = produtoDestaque.valor_boleto

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0) {
            percentualDescontoOferta = (100 - (produtoDestaque.valor_boleto / produtoDestaque.valor_de * 100))
        }
    } else if (precoPrincipal == 2 && produtoDestaque.valor_cartao && produtoDestaque.valor_cartao[0] > 0) {
        precoOferta = produtoDestaque.valor_cartao[5] ? produtoDestaque.valor_cartao[5].valor : produtoDestaque.valor_cartao[1]

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0) {
            percentualDescontoOferta = (100 - (precoOferta / produtoDestaque.valor_de * 100))
        }
    } else if (precoPrincipal == 4 && produtoDestaque.valor_pix && produtoDestaque.valor_pix > 0) {
        precoOferta = produtoDestaque.valor_pix

        if (produtoDestaque.valor_de && produtoDestaque.valor_de > 0) {
            percentualDescontoOferta = (100 - (produtoDestaque.valor_pix / produtoDestaque.valor_de * 100))
        }
    }

    const hasOldPrice = Boolean(produtoDestaque.valor_de && produtoDestaque.valor_de > precoOferta && precoOferta > 0)
    const hasPrice = precoOferta > 0

    return (
        <div className="produto-principal">
            <a href={getLinkProduto(produtoDestaque)}>
                <div className="box-img-produto-principal">
                    {(percentualDescontoOferta && percentualDescontoOferta > 0) && (
                        <span className="box-desc flex">
                            <span className="porc flex center">{Math.round(percentualDescontoOferta)} %</span>
                            <span className="txt-por flex center">OFF</span>
                        </span>
                    )}
                    <div className="box-img">
                        <figure>
                            <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produtoDestaque}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />

                            {utilizaFavoritosVitrine && <FavoriteButton produto={produtoDestaque} />}
                        </figure>
                    </div>
                </div>

                {!exibeValoresSomenteLogado && (
                    <>
                        <div className="box-info-oferta">
                            <h3 className="title-prd-oferta">{produtoDestaque.nome}</h3>
                            <div className="price-oferta">
                                {hasOldPrice && (
                                    <span className="old-price-oferta">De: {priceFormatter.format(produtoDestaque.valor_de)}</span>
                                )}
                                {hasPrice && (
                                    <span className="price">Por: {priceFormatter.format(precoOferta)}</span>
                                )}
                            </div>
                        </div>

                        <div className="button button-full button-buy">{vitrineButtonAddToCart}</div>
                    </>
                )}
            </a>

            {exibeValoresSomenteLogado && (
                <div className="valores-logados-vitrine">
                    <span>
                        Faça login para ver os preços
                    </span>

                    <a
                        href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`}
                        className="btn-comprar-vitrine flex center justify-center"
                    >
                        Fazer login
                    </a>
                </div>
            )}
        </div>
    )
}
